<template>
  <nav class="navbar navbar-expand-lg navbar-light rms-nav-bar">
    <div v-if="logo" class="d-flex mr-5 align-items-center">
      <a
        href="#"
        ref="companyLogo"
        class="navbar-brand pl-md-0 pl-4"
        @click.prevent="goHome"
        style="background-size: 100%; width: 205px"
      >
      </a>
    </div>
    <a v-else class="navbar-brand" href="#">{{ company.name }}</a>

    <div
      class="navbar-toggler border-0"
      type="button"
      data-toggle="collapse"
      data-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
      @click.prevent="navToggler = !navToggler"
      >
      <div v-if="notificationCount" class="notification-circle ml-auto mr-n2 mb-n1"></div>
      <svg
        v-if="navToggler"
        width="20"
        height="15"
        viewBox="0 0 20 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.750859 12.9997H19.2509C19.6651 12.9997 20.0009 13.3355 20.0009 13.7497C20.0009 14.1294 19.7187 14.4432 19.3526 14.4928L19.2509 14.4997H0.750859C0.336646 14.4997 0.000859261 14.1639 0.000859261 13.7497C0.000859261 13.37 0.283013 13.0562 0.649089 13.0065L0.750859 12.9997H19.2509H0.750859ZM0.750859 6.5027H19.2509C19.6651 6.5027 20.0009 6.83848 20.0009 7.2527C20.0009 7.63239 19.7187 7.94619 19.3526 7.99585L19.2509 8.0027H0.750859C0.336646 8.0027 0.000859261 7.66691 0.000859261 7.2527C0.000859261 6.873 0.283013 6.55921 0.649089 6.50954L0.750859 6.5027H19.2509H0.750859ZM0.75 0.00292969H19.25C19.6642 0.00292969 20 0.338716 20 0.75293C20 1.13263 19.7178 1.44642 19.3518 1.49608L19.25 1.50293H0.75C0.335786 1.50293 0 1.16714 0 0.75293C0 0.373234 0.282154 0.0594385 0.64823 0.00977612L0.75 0.00292969H19.25H0.75Z"
          fill="#1E5083"
        />
      </svg>
      <svg
        v-else
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.397052 0.553788L0.46967 0.46967C0.735936 0.203403 1.1526 0.179197 1.44621 0.397052L1.53033 0.46967L8 6.939L14.4697 0.46967C14.7626 0.176777 15.2374 0.176777 15.5303 0.46967C15.8232 0.762563 15.8232 1.23744 15.5303 1.53033L9.061 8L15.5303 14.4697C15.7966 14.7359 15.8208 15.1526 15.6029 15.4462L15.5303 15.5303C15.2641 15.7966 14.8474 15.8208 14.5538 15.6029L14.4697 15.5303L8 9.061L1.53033 15.5303C1.23744 15.8232 0.762563 15.8232 0.46967 15.5303C0.176777 15.2374 0.176777 14.7626 0.46967 14.4697L6.939 8L0.46967 1.53033C0.203403 1.26406 0.179197 0.8474 0.397052 0.553788L0.46967 0.46967L0.397052 0.553788Z"
          fill="#1E5083"
        />
      </svg>
    </div>
    <div class="collapse navbar-collapse" id="navbarNav">
      <div class="d-lg-flex flex-row flex-md-row-reverse w-100 mt-2">
        <ul class="navbar-nav ml-md-auto" v-if="user">
          <li class="nav-item d-none d-md-block mt-3">
            <AppNotification v-if="!isMobile" :user="user"/>
          </li>
          <li class="nav-item">
            <div class="d-flex align-items-center">
              <SfeAvatar
                class="mr-3"
                size="sm"
                :initials="
                  $helpers.createInitials(
                    user.first_name,
                    user.last_name
                  )
                "
                :alt="
                  $helpers.createInitials(
                    user.first_name,
                    user.last_name
                  )
                "
                status="success"
                :key="user.avatar"
                :src="user.avatar || ''"
              />
              <div class="ml-n2 text-muted d-none d-md-block cursor-pointer">
                <div class="dropleft">
                  <span
                    class="material-icons"
                    data-toggle="dropdown"
                    aria-expanded="false"
                    data-offset="10,20"
                  >
                    keyboard_arrow_down
                  </span>
                  <div class="dropdown-menu mt-5 mr-n4">
                    <div
                      class="dropdown-item text-primary"
                      @click.prevent="goLogout"
                    >
                      Log out
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
            <SfeButton class="btn btn-primary mr-3 text-white" @click.prevent="goHome" v-else>
              Get started
            </SfeButton>
        <ul class="navbar-nav">
          <li
            class="nav-item mr-3"
            data-toggle="collapse"
            data-target="#navbarNav"
            v-if="$route"
            :class="{
              active:
                $route &&
                [
                  'Jobs.Lists',
                  'Job.Application.Form',
                  'Preview.Application',
                  'View.Job',
                  'Application.Successful',
                ].includes($route.name),
            }"
          >
            <a
              class="nav-link d-flex align-items-center"
              href="#"
              @click.prevent="goTo('Jobs.Lists')"
            >
              <svg
                v-if="
                  $route &&
                  ![
                    'Jobs.Lists',
                    'Job.Application.Form',
                    'Preview.Application',
                    'View.Job',
                    'Application.Successful',
                  ].includes($route.name)
                "
                width="21"
                height="18"
                viewBox="0 0 21 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.75 0C2.23122 0 1 1.23122 1 2.75V7.25716C1.44631 6.88857 1.95177 6.58904 2.5 6.37494V2.75C2.5 2.05964 3.05964 1.5 3.75 1.5H18.25C18.9404 1.5 19.5 2.05964 19.5 2.75V13.25C19.5 13.9404 18.9404 14.5 18.25 14.5H9.97487L11.4749 16H18.25C19.7688 16 21 14.7688 21 13.25V2.75C21 1.23122 19.7688 0 18.25 0H3.75ZM7.66308 7C8.23554 7.40313 8.72762 7.91272 9.11053 8.5H16.25C16.6642 8.5 17 8.16421 17 7.75C17 7.33579 16.6642 7 16.25 7H7.66308ZM14.25 11.5H10C10 10.98 9.92783 10.4768 9.79297 10H14.25C14.6642 10 15 10.3358 15 10.75C15 11.1642 14.6642 11.5 14.25 11.5ZM5.75 4C5.33579 4 5 4.33579 5 4.75C5 5.16421 5.33579 5.5 5.75 5.5H12.25C12.6642 5.5 13 5.16421 13 4.75C13 4.33579 12.6642 4 12.25 4H5.75ZM4.5 16C5.47187 16 6.37179 15.6919 7.1074 15.1681L9.71967 17.7803C10.0126 18.0732 10.4874 18.0732 10.7803 17.7803C11.0732 17.4874 11.0732 17.0126 10.7803 16.7197L8.16806 14.1074C8.69191 13.3718 9 12.4719 9 11.5C9 9.01472 6.98528 7 4.5 7C2.01472 7 0 9.01472 0 11.5C0 13.9853 2.01472 16 4.5 16ZM4.5 14.5C2.84315 14.5 1.5 13.1569 1.5 11.5C1.5 9.84315 2.84315 8.5 4.5 8.5C6.15685 8.5 7.5 9.84315 7.5 11.5C7.5 13.1569 6.15685 14.5 4.5 14.5Z"
                  fill="#777777"
                />
              </svg>
              <svg
                v-else
                width="21"
                height="18"
                viewBox="0 0 21 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 2.75C1 1.23122 2.23122 0 3.75 0H18.25C19.7688 0 21 1.23122 21 2.75V13.25C21 14.7688 19.7688 16 18.25 16H11.4749L9.42531 13.9504C9.79312 13.2126 10 12.3805 10 11.5H14.25C14.6642 11.5 15 11.1642 15 10.75C15 10.3358 14.6642 10 14.25 10H9.79297C9.64079 9.46195 9.40877 8.95741 9.11053 8.5H16.25C16.6642 8.5 17 8.16421 17 7.75C17 7.33579 16.6642 7 16.25 7H7.66308C6.76841 6.36997 5.67741 6 4.5 6C3.17037 6 1.95094 6.47182 1 7.25716V2.75ZM5.75 4C5.33579 4 5 4.33579 5 4.75C5 5.16421 5.33579 5.5 5.75 5.5H12.25C12.6642 5.5 13 5.16421 13 4.75C13 4.33579 12.6642 4 12.25 4H5.75ZM4.5 16C5.47187 16 6.37179 15.6919 7.1074 15.1681L9.71967 17.7803C10.0126 18.0732 10.4874 18.0732 10.7803 17.7803C11.0732 17.4874 11.0732 17.0126 10.7803 16.7197L8.16806 14.1074C8.69191 13.3718 9 12.4719 9 11.5C9 9.01472 6.98528 7 4.5 7C2.01472 7 0 9.01472 0 11.5C0 13.9853 2.01472 16 4.5 16ZM4.5 14.5C2.84315 14.5 1.5 13.1569 1.5 11.5C1.5 9.84315 2.84315 8.5 4.5 8.5C6.15685 8.5 7.5 9.84315 7.5 11.5C7.5 13.1569 6.15685 14.5 4.5 14.5Z"
                  fill="#307DCC"
                />
              </svg>
              &nbsp;Find jobs <span class="sr-only">(current)</span></a
            >
          </li>
          <li
            class="nav-item mr-3"
             data-toggle="collapse"
             data-target="#navbarNav"
            v-if="!!user"
            :class="{
              active:
                $route &&
                [
                  'MyApplication',
                  'MyOverview',
                  'MyApplication.Overview',
                  'MyApplication.Message',
                  'MyApplication.Document',
                ].includes($route.name),
            }"
          >
            <a
              href="#"
              class="nav-link d-flex align-items-center"
              @click.prevent="goTo('MyApplication')"
            >
              <svg
                v-if="
                  $route &&
                  [
                    'MyApplication',
                    'MyApplication.Overview',
                    'MyApplication.Message',
                    'MyApplication.Document',
                  ].includes($route.name)
                "
                width="19"
                height="17"
                viewBox="0 0 19 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.0312 0C13.4455 0 13.7812 0.335786 13.7812 0.75V4H15.5312C17.3262 4 18.7812 5.45507 18.7812 7.25V13.75C18.7812 15.5449 17.3262 17 15.5312 17H4.03125C2.23632 17 0.78125 15.5449 0.78125 13.75V7.25C0.78125 5.45507 2.23632 4 4.03125 4H5.78125V0.75C5.78125 0.370304 6.0634 0.0565091 6.42948 0.00684667L6.53125 0H13.0312ZM12.2812 1.5H7.28125V4H12.2812V1.5Z"
                  fill="#307DCC"
                />
              </svg>
              <svg
                v-else
                width="18"
                height="17"
                viewBox="0 0 18 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.75 0H12.25C12.6297 0 12.9435 0.282154 12.9932 0.648229L13 0.75V4H14.75C16.5449 4 18 5.45507 18 7.25V13.75C18 15.5449 16.5449 17 14.75 17H3.25C1.45507 17 0 15.5449 0 13.75V7.25C0 5.45507 1.45507 4 3.25 4H5V0.75C5 0.370304 5.28215 0.0565091 5.64823 0.00684667L5.75 0H12.25H5.75ZM14.75 5.5H3.25C2.2835 5.5 1.5 6.2835 1.5 7.25V13.75C1.5 14.7165 2.2835 15.5 3.25 15.5H14.75C15.7165 15.5 16.5 14.7165 16.5 13.75V7.25C16.5 6.2835 15.7165 5.5 14.75 5.5ZM11.5 1.5H6.5V4H11.5V1.5Z"
                  fill="#777777"
                />
              </svg>
              &nbsp;My applications
            </a>
          </li>
          <li
            class="nav-item mr-3 d-lg-none"
            v-if="!!user"
            >
            <a
              href="#"
              class="nav-link d-flex align-items-center"
            >
              <svg
                width="18"
                height="21"
                viewBox="0 0 18 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.99889 0.996094C13.0488 0.996094 16.3556 4.19084 16.4947 8.24515L16.4989 8.49609V12.5931L17.8789 15.7491C17.9479 15.907 17.9836 16.0775 17.9836 16.2499C17.9836 16.9402 17.424 17.4999 16.7336 17.4999L11.9989 17.5014C11.9989 19.1582 10.6557 20.5014 8.99889 20.5014C7.40121 20.5014 6.09523 19.2524 6.00398 17.6776L5.99844 17.4991L1.27375 17.4999C1.10242 17.4999 0.932907 17.4646 0.775753 17.3964C0.142551 17.1213 -0.147798 16.3851 0.127241 15.7519L1.49889 12.594V8.49599C1.49949 4.3412 4.85098 0.996094 8.99889 0.996094ZM10.4984 17.4991L7.49889 17.5014C7.49889 18.3298 8.17046 19.0014 8.99889 19.0014C9.77859 19.0014 10.4193 18.4065 10.492 17.6458L10.4984 17.4991ZM8.99889 2.49609C5.67873 2.49609 2.99937 5.17035 2.99889 8.49609V12.9057L1.65491 15.9999H16.3514L14.9989 12.9067L14.999 8.50895L14.9953 8.28375C14.8842 5.05027 12.2405 2.49609 8.99889 2.49609Z"
                  fill="#777777"
                />
              </svg>
              &nbsp;<AppNotification  v-if="isMobile" :user="user" :isMobile="isMobile" @notification-count="getNotificationCount"/>
            </a>
          </li>
          <li class="nav-item mr-3 d-lg-none" v-if="!!user">
            <a
              href="#"
              class="nav-link d-flex align-items-center"
              @click.prevent="goLogout"
            >
              <svg
                width="15"
                height="14"
                viewBox="0 0 15 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.5 8.25C5.91421 8.25 6.25 7.91422 6.25 7.5C6.25 7.08579 5.91421 6.75 5.5 6.75C5.08579 6.75 4.75 7.08579 4.75 7.5C4.75 7.91422 5.08579 8.25 5.5 8.25ZM8 0.500004C8 0.354204 7.93636 0.215666 7.82575 0.120678C7.71514 0.0256898 7.56857 -0.0162863 7.42445 0.00574443L0.424449 1.07574C0.180316 1.11306 0 1.32303 0 1.57V12.43C0 12.6769 0.180277 12.8869 0.424378 12.9243L7.42438 13.9953C7.56851 14.0173 7.71509 13.9754 7.82572 13.8804C7.93635 13.7854 8 13.6468 8 13.501V7.00002L13.1722 7.00002L12.1753 7.87372C11.9679 8.05556 11.9468 8.37144 12.1284 8.57926C12.3099 8.78708 12.6253 8.80814 12.8328 8.6263L14.8295 6.8763C14.9379 6.78135 15 6.64419 15 6.50001C15 6.35583 14.9379 6.21867 14.8295 6.12372L12.8328 4.37372C12.6253 4.19188 12.3099 4.21294 12.1284 4.42076C11.9468 4.62858 11.9679 4.94446 12.1753 5.1263L13.1723 6.00002L8 6.00002V0.500004ZM7 1.08224V12.9187L1 12.0007V1.99938L7 1.08224ZM9.5 13H9V8H10V12.5C10 12.7761 9.77614 13 9.5 13ZM9 5V1H9.5C9.77614 1 10 1.22386 10 1.5V5H9Z"
                  fill="#777777"
                />
              </svg>
              &nbsp;Log out
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import SideBar from "./SideBar";
import AppNotification from "./AppNotification"
import AlertService from "../services/AlertService";

export default {
  components: { SideBar, AppNotification },
  mixins: [AlertService],
  props: {
    logo: {
      type: String,
      required: false,
    },
    company: {
      type: Object,
      default: () => ({}),
      required: false,
    },
    user: {
      required: false,
    },
  },
  data() {
    return {
      showSideBar: false,
      navToggler: true,
      isMobile: false,
      notificationCount: 0
    }
  },

  mounted() {
    // sessionStorage.setItem('company', JSON.stringify(this.company))
    this.$store.commit("SET_COMPANY_LOGO", this.logo);
    if (this.user) {
      if (this.user.verified_at) {
        this.$store.commit("SET_LOGGED_IN_USER", this.user);
      } else {
        this.$store.commit("SET_SHOW_VERIFICATION", this.user.email);
      }
    }
    this.$refs.companyLogo.style.background = "url(" + this.logo + ")";
    this.$refs.companyLogo.style.backgroundPosition = "center";
    if(screen.width <= 991){
      this.isMobile = true
    }
  },
  methods: {
    goTo(name){
      this.navToggler = !this.navToggler
      if (name === 'Jobs.Lists') {
        const origin = window.location.origin
        const route = `${origin}/h/advanced#/jobs`
        window.location.href= route
      } else {
        this.$router.push({name})
      }
    },
    goHome() {
      location.href = "/";
    },
    goLogout() {
      this.showInfoPrompt('Are you sure that you want to logout?', 'Logout')
        .then((r) => {
          if (r.isConfirmed) {
            sessionStorage.clear()
            localStorage.clear()
            location.href = "/logout";
          }
        })
    },
    getNotificationCount(count){
      this.notificationCount = count
    }
  },
};
</script>

<style scoped lang="scss">
.notification-circle{
  background: #C92B2B;
  border-radius: 100px;
  width: 8px;
  height: 8px;
}
body {
  padding-top: 60px;
  border: 10px solid red;
}
.navbar {
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  top: 0;
}
.navbar-brand {
  min-height: 50px;
  min-width: 100px;
  background-size: contain !important;
  width: auto !important;
  background-repeat: no-repeat !important;
}
.navbar-toggler {
  border-color: rgb(255, 102, 203);
}
.active {
  position: relative;
  color: #296db3;
  * {
    color: #296db3 !important;
  }
  &:after {
    position: absolute;
    bottom: -11px;
    left: 0;
    content: "";
    background: #296db3;
    height: 4px;
    width: 100%;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
}
@media only screen and (max-width: 991px) {
  .active {
    position: relative;
    color: #296db3;
    * {
      background-color: #f4f7fb !important;
    }
    &:after {
      position: absolute;
      bottom: 0;
      left: 0;
      content: none;
    }
  }
}
</style>
